import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
    container: {
        width: '100%',
    },
    trackContainer: {
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
    },
    track: {
        flex: 1,
        backgroundColor: '#F3F4F6',
        overflow: 'hidden',
    },
    progress: {
        height: '100%',
    },
    percentInside: {
        position: 'absolute',
        right: 8,
        alignSelf: 'center',
    },
    percentRight: {
        marginLeft: 8,
    },
    percentFollow: {
        position: 'absolute',
        alignSelf: 'center',
    },
    percentText: {
        fontSize: 12,
        fontWeight: '600',
        color: '#FFFFFF',
    },
    indicatorContainer: {
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

export const defaultColors = {
    progress: '#FF3B30',
    track: '#F3F4F6',
    percentInside: '#FFFFFF',
    percentOutside: '#333333',
};
